module.exports = __webpack_public_path__ + "static/media/davide.bfb9f43a.jpg";